import React, {useEffect, useState} from "react";
import { Modal } from "react-bootstrap";
import TermAboutMeForm from "../../CustomizeTerm/steps/AboutMeForm";
import "./BasicInfoSummary.scss"
import PropTypes from 'prop-types';
import BasicInfo from "../BasicInfo";
import validateBMI from "../../Americo/Helpers/ValidateBMI";
import AboutMeForm from "../../MCT/steps/AboutMeForm";
import SvgIcon from '@material-ui/core/SvgIcon';
import GroupIcon from "../../../../../src/icons/model-group.svg";
import ScaleIcon from "../../../../../src/icons/model-scale.svg";
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from "../../../../sessionStorage";

export default function BasicInfoSummaryModel(props) {
    const ageSpecs = props.ageSpecs || { min: 18, max: 70 };
    const americoUnavailableStates = ["NY", "VI"];
    const securianUnavailableStates = ["CA", "NY"];

    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const [primaryBrandColor, setPrimaryBrandColor] = useState(null);  
    
    useEffect(() => {
        if (!accountObj.accountOverrides) {
          setPrimaryBrandColor(accountObj.account.primaryColor);
        } else {
          setPrimaryBrandColor(accountObj.accountOverrides.primaryColor);
        }
      }, []);

    const onFieldChange = (field, value) => {
        if (props.onFieldChange) {
            let step = null;
            if (props.product === 'loanprotector' || props.product === 'securianwl') {
                step = 'basicInfo';
            } else if (props.product === 'term2') {
                step = 'aboutMe';
            }
            props.onFieldChange(field, value, step);
        }
    }

    const tobaccoOptions = props.product === 'loanprotector' ? [
        { label: "Within the last year", value: "Within the last year" },
        { label: "Within the last 13-36 months", value: "Within the last 13-36 months" },
        { label: "Over 36 months ago", value: "Over 36 months" },
        { label: "Never", value: "Never" },
    ] : null;
    
    return (
        <Modal 
            show={props.openEditPopUp} 
            onHide={props.closeModal} 
            onClose={props.closeModal}
            backdrop="true"
            className="basicInfo-modal icon-bg">
            <Modal.Header className="d-flex justify-content-center" closeButton>
                <Modal.Title className="modal-title">{props.isPurlVerification ? "Confirm Your Information" : "Your Insurance Profile"}</Modal.Title>
                <div className="group-icon"><SvgIcon color='primary' component={GroupIcon} className="icon" viewBox="0 0 80 81" /></div>
            </Modal.Header>
            <Modal.Body className="form-content d-flex justify-content-center">
                {props.product === 'term3' ? (
                <TermAboutMeForm 
                    ageSpecs={props.isAmerico ? {min: 18, max: 65 } : { min: 18, max: 70 }} 
                    hideNextButton={true} 
                    hideCoverage={true} 
                    showQuoteButton={props.openEditPopUp} 
                    setOpenEditPopUp={props.setOpenEditPopUp} 
                    openEditPopUp={props.openEditPopUp}
                    isPurlVerification={props.isPurlVerification}
                    selectedQuote={props.selectedQuote} 
                    brandTheme={primaryBrandColor}
                    unavailableStates={props.isAmerico && americoUnavailableStates}
                    isAmerico={props.isAmerico} />
                ) : props.product === 'term2' ? (
                <AboutMeForm 
                    onFieldChange={onFieldChange}
                    ageSpecs={props.isAmerico ? {min: 18, max: 65 } : { min: 18, max: 70 }} 
                    hideNextButton={true} 
                    hideCoverage={true} 
                    showQuoteButton={props.openEditPopUp} 
                    setOpenEditPopUp={props.setOpenEditPopUp} 
                    openEditPopUp={props.openEditPopUp}
                    isPurlVerification={props.isPurlVerification}
                    selectedQuote={props.selectedQuote}
                    brandTheme={primaryBrandColor}
                    submitButtonVariant='purl' />
                ) : (
                <BasicInfo
                    formState={props.formState}
                    onFieldChange={onFieldChange}
                    openEditPopUp={props.openEditPopUp}
                    setOpenEditPopUp={props.setOpenEditPopUp} 
                    isPurlVerification={props.isPurlVerification}
                    selectedQuote={props.selectedQuote}
                    hideBack={true}
                    juviMode={props.juviMode}
                    ageSpecs={ageSpecs}
                    unavailableStates={props.product === 'loanprotector' ? americoUnavailableStates : securianUnavailableStates}
                    validateBMI={(totalHeight, bmi, weight) => validateBMI(totalHeight, bmi, weight)}
                    tobaccoOptions={tobaccoOptions}
                    brandTheme={primaryBrandColor}
                    tobaccoToTrueFalseString={(value) => (value !== 'Never').toString()} />
                )}
           </Modal.Body>
            <div className="Scale-icon"><SvgIcon component={ScaleIcon} color='primary' className="icon" viewBox="0 0 109 85" /></div>
        </Modal>
    )
}

BasicInfoSummaryModel.propTypes = {
    closeModal: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/SubComponents/BasicInfoSummaryModel.js